import { render, staticRenderFns } from "./getfree_new.vue?vue&type=template&id=473b3b2e&scoped=true"
import script from "./getfree_new.vue?vue&type=script&lang=js"
export * from "./getfree_new.vue?vue&type=script&lang=js"
import style0 from "./getfree_new.vue?vue&type=style&index=0&id=473b3b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b3b2e",
  null
  
)

export default component.exports